/**
 * Validation schemas for the modern auth flow component.
 *
 * Aliases: auth flow schemas, authentication validation
 */

import { z } from "zod";

export const emailSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required.")
    .email("Invalid email address."),
});

export type EmailForm = z.infer<typeof emailSchema>;

export const passwordSchema = z.object({
  password: z
    .string()
    .min(1, "Please enter your password.")
    .min(8, "Your password must have 8 characters or more."),
});

export type PasswordForm = z.infer<typeof passwordSchema>;

export const signupCredentialsSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, "First name is required.")
    .max(50, "First name must be 50 characters or less."),
  lastName: z
    .string()
    .trim()
    .min(1, "Last name is required.")
    .max(50, "Last name must be 50 characters or less."),
  password: z
    .string()
    .min(1, "Please enter your password.")
    .min(8, "Your password must have 8 characters or more."),
});

export type SignupCredentialsForm = z.infer<typeof signupCredentialsSchema>;
